import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles(() => ({
  root: {
    width: '100vw',
    height: '100vh',
    display: 'flex',
    top: 0,
    left: 0,
    justifyContent: 'center',
    position: 'fixed',
    backgroundColor: 'var(--color-backgroundColors-grey)',
    alignItems: 'center',
    zIndex: 4000,
    '& .loading': {
      backgroundColor: 'var(--color-white)',
      borderRadius: 8,
      width: 80,
      height: 80,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',

      '& .MuiCircularProgress-indeterminate': {
        animationDuration: '0.9s',
      },
    },
  },
}));

const MasterLoadingPage = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div className="loading">
        <CircularProgress disableShrink />
      </div>
    </div>
  );
};

export default MasterLoadingPage;
